import type { ZeytalTokens } from "@zeytal/types";

import { camelize } from "@endgame/utils/camelize";

import { variableAliasKeyword } from "../../utils/tokens.ts";

const formatName = (name: ZeytalTokens.TransformedToken["name"]) => {
  return `${camelize(name)}`;
};

const booleanValue = (boolean: boolean) => `${boolean}`;

const numberValue = (number: number) => number.toString();

const stringValue = (string: string) => {
  return string.startsWith(variableAliasKeyword)
    ? formatName(string.replace(variableAliasKeyword, ""))
    : `"${string}"`;
};

const formatValue = (value: ZeytalTokens.TransformedToken["value"]): string => {
  switch (typeof value) {
    case "boolean":
      return booleanValue(value);
    case "number":
      return numberValue(value);
    case "string":
      return stringValue(value);
    default:
      return "null";
  }
};

export const translateEsm = (variables: ZeytalTokens.TransformedTokensArray) =>
  variables.reduce(
    (acc, item) =>
      `${acc}export const ${formatName(item.name)} = ${formatValue(item.value)};\n`,
    "",
  );
